import { useContext } from "react";
import { FormContextMA } from "../form-context";
import {
  allergensAndIrritantsEffectiveEnum,
  intranasalAntihistaminesAndCorticosteroidsLengthEnum,
  intranasalCorticosteroidsLengthEnum,
  nasalIrrigationsLengthEnum,
  nasalOrOralDecongestantsLengthEnum,
  oralAntihistaminesLengthEnum,
} from "../../patient/clinical-services/service-steps/treatment/data";
import {
  Section,
  H2,
  H3,
  P,
  CheckInput,
  DataField,
  TealSubSection,
  Divider,
} from "./common-components";
import { GetAlertConfirmation } from "../../../helpers/constant";

export const TreatmentInformation = ({treatment, formType}) => {
  // const { treatment } = useContext(FormContextMA);

  return (
    <Section formType={formType}>
      <H2>Treatment Information</H2>
      <div className="space-y-4">
        <H3>Treatment History (if applicable)</H3>
        <CheckInput
          checked={
            !treatment?.nasalIrrigations?.length &&
            !treatment?.nasalOrOralDecongestants?.length &&
            !treatment?.oralAntihistamines &&
            !treatment?.intranasalCorticosteroids &&
            !treatment?.intranasalAntihistaminesAndCorticosteroids
          }
          label="No past medications"
        />
      </div>
      <Divider />
      <div className="space-y-4">
        <H3>Non-Pharmacologic Treatment</H3>
        <CheckInput
          label="Allergen/Irritant Avoidance"
          checked={!!treatment?.allergensAndIrritants}
        />
        <div className="ml-[0.25in] space-y-[0.0833333in]">
          <div className="grid grid-cols-3 gap-[0.104167in]">
            <P>{allergensAndIrritantsEffectiveEnum.question}</P>
            <CheckInput
              radio
              checked={!!treatment?.allergensAndIrritantsEffective}
              label="Yes"
            />
            <CheckInput
              radio
              checked={!treatment?.allergensAndIrritantsEffective}
              label="No"
            />
          </div>
        </div>
        <div className="space-y-[0.0833333in]">
          <CheckInput
            checked={!!treatment?.nasalIrrigations?.length}
            label="Nasal Irrigation/Nasal Lubricant(s)"
          />
          {treatment?.nasalIrrigations?.length ? (
            <div className="ml-[0.25in] space-y-[0.0833333in]">
              <DataField
                label="How long did you use the medication(s)?"
                value={
                  nasalIrrigationsLengthEnum.options.find(
                    (v) => v.value === treatment?.nasalIrrigationsLength
                  )?.header || ""
                }
              />
              <div className="grid grid-cols-3 gap-[0.104167in]">
                <P>Was it effective?</P>
                <CheckInput
                  radio
                  checked={!!treatment?.nasalIrrigationsEffective}
                  label="Yes"
                />
                <CheckInput
                  radio
                  checked={!treatment?.nasalIrrigationsEffective}
                  label="No"
                />
              </div>
              <div className="grid grid-cols-3 gap-[0.104167in]">
                <P>Any side effects?</P>
                <CheckInput
                  radio
                  checked={!!treatment?.nasalIrrigationsSideEffects}
                  label="Yes"
                />
                <CheckInput
                  radio
                  checked={!treatment?.nasalIrrigationsSideEffects}
                  label="No"
                />
              </div>
              <DataField
                label="Comments"
                value={treatment?.nasalIrrigationsComments || ""}
              />
            </div>
          ) : null}
        </div>
      </div>
      <div className="pt-4 space-y-[0.166667in]">
        <H3>Pharmacologic Treatment</H3>
        <div className="space-y-[0.0833333in]">
          <CheckInput
            checked={!!treatment?.nasalOrOralDecongestants?.length}
            label="Oral and/or Nasal Decongestant(s)"
          />
          {treatment?.nasalOrOralDecongestants?.length ? (
            <div className="ml-[0.25in] space-y-[0.0833333in]">
              <DataField
                label="How long did you use the medication(s)?"
                value={
                  nasalOrOralDecongestantsLengthEnum.options.find(
                    (v) => v.value === treatment?.nasalOrOralDecongestantsLength
                  )?.header || ""
                }
              />
              <div className="grid grid-cols-3 gap-[0.104167in]">
                <P>Was it effective?</P>
                <CheckInput
                  radio
                  checked={!!treatment?.nasalOrOralDecongestantsEffective}
                  label="Yes"
                />
                <CheckInput
                  radio
                  checked={!treatment?.nasalOrOralDecongestantsEffective}
                  label="No"
                />
              </div>
              <div className="grid grid-cols-3 gap-[0.104167in]">
                <P>Any side effects?</P>
                <CheckInput
                  radio
                  checked={!!treatment?.nasalOrOralDecongestantsSideEffects}
                  label="Yes"
                />
                <CheckInput
                  radio
                  checked={!treatment?.nasalOrOralDecongestantsSideEffects}
                  label="No"
                />
              </div>
              <DataField
                label="Comments"
                value={treatment?.nasalOrOralDecongestantsComments || ""}
              />
            </div>
          ) : null}
        </div>
        <div className="space-y-[0.0833333in]">
          <CheckInput
            checked={!!treatment?.oralAntihistamines}
            label="Oral antihistamine(s)"
          />
          {treatment?.oralAntihistamines ? (
            <div className="ml-[0.25in] space-y-[0.0833333in]">
              <DataField
                label="How long did you use the medication(s)?"
                value={
                  oralAntihistaminesLengthEnum.options.find(
                    (v) => v.value === treatment?.oralAntihistaminesLength
                  )?.header || ""
                }
              />
              <div className="grid grid-cols-3 gap-[0.104167in]">
                <P>Was it effective?</P>
                <CheckInput
                  radio
                  checked={!!treatment?.oralAntihistaminesEffective}
                  label="Yes"
                />
                <CheckInput
                  radio
                  checked={!treatment?.oralAntihistaminesEffective}
                  label="No"
                />
              </div>
              <div className="grid grid-cols-3 gap-[0.104167in]">
                <P>Any side effects?</P>
                <CheckInput
                  radio
                  checked={!!treatment?.oralAntihistaminesSideEffects}
                  label="Yes"
                />
                <CheckInput
                  radio
                  checked={!treatment?.oralAntihistaminesSideEffects}
                  label="No"
                />
              </div>
              <DataField
                label="Comments"
                value={treatment?.oralAntihistaminesComments || ""}
              />
            </div>
          ) : null}
        </div>
        <div className="space-y-[0.0833333in]">
          <CheckInput
            checked={!!treatment?.intranasalCorticosteroids}
            label="Intranasal Corticosteroid(s)"
          />
          {treatment?.intranasalCorticosteroids ? (
            <div className="ml-[0.25in] space-y-[0.0833333in]">
              <DataField
                label="How long did you use the medication(s)?"
                value={
                  intranasalCorticosteroidsLengthEnum.options.find(
                    (v) =>
                      v.value === treatment?.intranasalCorticosteroidsLength
                  )?.header || ""
                }
              />
              <div className="grid grid-cols-3 gap-[0.104167in]">
                <P>Was it effective?</P>
                <CheckInput
                  radio
                  checked={!!treatment?.intranasalCorticosteroidsEffective}
                  label="Yes"
                />
                <CheckInput
                  radio
                  checked={!treatment?.intranasalCorticosteroidsEffective}
                  label="No"
                />
              </div>
              <div className="grid grid-cols-3 gap-[0.104167in]">
                <P>Any side effects?</P>
                <CheckInput
                  radio
                  checked={!!treatment?.intranasalCorticosteroidsSideEffects}
                  label="Yes"
                />
                <CheckInput
                  radio
                  checked={!treatment?.intranasalCorticosteroidsSideEffects}
                  label="No"
                />
              </div>
              <DataField
                label="Comments"
                value={treatment?.intranasalCorticosteroidsComments || ""}
              />
            </div>
          ) : null}
        </div>
        <div className="space-y-[0.0833333in]">
          <CheckInput
            checked={
              !!treatment?.intranasalAntihistaminesAndCorticosteroids
            }
            label="Intranasal Antihistamine/Corticosteroid"
          />
          {treatment?.intranasalAntihistaminesAndCorticosteroids ? (
            <div className="ml-[0.25in] space-y-[0.0833333in]">
              <DataField
                label="How long did you use the medication(s)?"
                value={
                  intranasalAntihistaminesAndCorticosteroidsLengthEnum.options.find(
                    (v) =>
                      v.value ===
                      treatment?.intranasalAntihistaminesAndCorticosteroidsLength
                  )?.header || ""
                }
              />
              <div className="grid grid-cols-3 gap-[0.104167in]">
                <P>Was it effective?</P>
                <CheckInput
                  radio
                  checked={
                    !!treatment?.intranasalAntihistaminesAndCorticosteroidsEffective
                  }
                  label="Yes"
                />
                <CheckInput
                  radio
                  checked={
                    !treatment?.intranasalAntihistaminesAndCorticosteroidsEffective
                  }
                  label="No"
                />
              </div>
              <div className="grid grid-cols-3 gap-[0.104167in]">
                <P>Any side effects?</P>
                <CheckInput
                  radio
                  checked={
                    !!treatment?.intranasalAntihistaminesAndCorticosteroidsSideEffects
                  }
                  label="Yes"
                />
                <CheckInput
                  radio
                  checked={
                    !treatment?.intranasalAntihistaminesAndCorticosteroidsSideEffects
                  }
                  label="No"
                />
              </div>
              <DataField
                label="Comments"
                value={
                  treatment?.intranasalAntihistaminesAndCorticosteroidsComments ||
                  ""
                }
              />
            </div>
          ) : null}
        </div>
        {treatment?.pharmacologicalHistoryConfirmationType !== 0 && (
          <TealSubSection className="space-y-[0.0416667in]">
            {/* TODO: data for values? */}
            <DataField
              label="Referral Reason"
              value={"Treatment History"}
            />
            <DataField
              label="Referral Type"
              value={GetAlertConfirmation(
                treatment?.pharmacologicalHistoryConfirmationType
              )}
            />
            {(treatment?.pharmacologicalHistoryConfirmationType === 1 ||
              treatment?.pharmacologicalHistoryConfirmationType === 2) && (
              <DataField
                label="Explanation"
                value={treatment?.pharmacologicalHistoryExplaination}
              />
            )}
            <DataField
              label={`Pharmacist Clinical Decision to ${
                treatment?.pharmacologicalHistoryConfirmationType === 4
                  ? "End Service"
                  : "Continue with Service"
              }`}
              value={""}
            />
          </TealSubSection>
        )}
      </div>
    </Section>
  );
};
